import { isMarkActive } from '../queries/isMarkActive.mjs';

function toggleMark(editor, type) {
  return isMarkActive(editor, type) ? editor.removeMark(type) : editor.addMark(type, true);
}

export { toggleMark };
